/**
 * @deprecated types are incomplete
 *  Take a function that expects varargs and turn it into a function that
    expects an array
*/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const gather = (fn: (...args: Array<any>) => any) => (args: unknown) =>
  // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
  fn.apply(this, args);
// Take the complement of a function
export const complement =
  <T>(f: (arg0: T) => boolean): ((arg0: T) => boolean) =>
  (...args) =>
    !f(...args);

/**
 * @deprecated types are incomplete
 */
export const partial =
  (
    f: (...args: Array<any>) => any, // eslint-disable-line @typescript-eslint/no-explicit-any
    ...args: Array<unknown>
  ) =>
  (...otherArgs: Array<unknown>) =>
    f(...args, ...otherArgs);
/**
 * @deprecated types are incomplete
 */
export const compose =
  (
    ...fargs: Array<(...args: Array<any>) => any> // eslint-disable-line @typescript-eslint/no-explicit-any
  ) =>
  (...initArgs: Array<unknown>) =>
    fargs
      .slice(0, -1)
      .reduceRight((acc, f) => f(acc), fargs[fargs.length - 1](...initArgs));
/**
* @deprecated types are incomplete
* Takes a function f and returns another function that returns the
  values that f would return, but wrapped in a promise
*/
export const wrapPromise =
  <T>(
    f: (arg0: any) => T, // eslint-disable-line @typescript-eslint/no-explicit-any
  ) =>
  (
    ...args: any // eslint-disable-line @typescript-eslint/no-explicit-any
  ): Promise<T> =>
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    Promise.resolve(f(...args));

export const identity = <T>(x: T): T => x;

export function identityFilter<T>(x: T | null | undefined | false): x is T {
  return x !== null && x !== undefined && x !== false;
}

export const defer = <T, U>(fn: (...args: Array<T>) => U) => setTimeout(fn, 0);
